import {AppLanguage} from '@app-shared/enums';

export const DEFAULT_APP_LANGUAGE: AppLanguage = AppLanguage.JAPANESE;
